export const weatherResistanceBreakpoints = [
  [0.01, 0.1], // 1 - Absolute worst
  [0.05, 0.3], // 2
  [0.1, 0.5], // 3
  [0.2, 0.8], // 4
  [0.3, 1.2], // 5
  [0.4, 1.8], // 6
  [0.5, 3], // 7
  [0.8, 4], // 8
  [1, 5], // 9 (migrated from old 1)
  [2, 8], // 10
  [5, 15], // 11
  [10, 20], // 12
  [12, 25], // 13
  [15, 50], // 14
  [20, 75], // 15
  [25, 125], // 16
  [35, 150], // 17
  [50, 200], // 18
  [50, Infinity], // 19 (migrated from 11, never rutty/high impact)
  [Infinity, Infinity], // 20 (migrated from 12, always firm/low impact)
]
